export default function getCurrentDate() {
  const date = new Date();

  return `${date.toISOString().split('T')[0]}T00:00`;
}
